import React, { createContext, useState, useContext } from 'react';

const PropertyContext = createContext();

export const PropertyProvider = ({ children }) => {
  const [propertyData, setPropertyData] = useState(null);
  const [roiResults, setRoiResults] = useState(null);

  const updatePropertyData = (data) => {
    setPropertyData(data);
  };

  const updateRoiResults = (results) => {
    setRoiResults(results);
  };

  const getPropertyContext = () => {
    if (!propertyData && !roiResults) return null;

    return {
      address: propertyData?.propertyAddress || '',
      purchasePrice: propertyData?.propertyPrice || '',
      downPayment: propertyData?.downpaymentPercentage ? 
        (parseFloat(propertyData.propertyPrice) * parseFloat(propertyData.downpaymentPercentage) / 100).toFixed(0) : '',
      monthlyRent: propertyData?.monthlyRent || '',
      propertyTax: propertyData?.propertyTax || '',
      insurance: propertyData?.yearlyInsurance || '',
      roi: roiResults?.annualReturnRate || roiResults?.capRate || '',
      cashFlow: roiResults?.monthlyCashFlow || '',
      capRate: roiResults?.capRate || '',
      totalMonthlyExpenses: roiResults?.totalMonthlyExpenses || '',
      annualCashFlow: roiResults?.annualCashFlow || '',
      propertyData,
      roiResults
    };
  };

  const value = {
    propertyData,
    roiResults,
    updatePropertyData,
    updateRoiResults,
    getPropertyContext
  };

  return (
    <PropertyContext.Provider value={value}>
      {children}
    </PropertyContext.Provider>
  );
};

export const useProperty = () => {
  const context = useContext(PropertyContext);
  if (!context) {
    throw new Error('useProperty must be used within a PropertyProvider');
  }
  return context;
};